export default __webpack_public_path__ + "images/a7b9e897e6e883bd7050e037a5838766.png";